import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Popover } from '@c2fo/liquidity';

interface AcceptanceTooltipProps {
  children: ReactNode;
}

const AcceptanceTooltip = ({ children }: AcceptanceTooltipProps) => {
  const { t } = useTranslation();

  return (
    <Popover>
      <Popover.Trigger aria-label={t('acceptance.tooltip')}>{children}</Popover.Trigger>
      <Popover.Content arrow collisionPadding={24}>
        <div className="w-56 text-center">{t('acceptance.tooltip')}</div>
      </Popover.Content>
    </Popover>
  );
};

export default AcceptanceTooltip;
